<template>
  <div class="card">
    <div class="card-body">
      <h4>Payment Schedule</h4>
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="upcoming-tab" data-bs-toggle="tab" data-bs-target="#upcoming"
            type="button" role="tab" aria-controls="upcoming" aria-selected="true">
            Upcoming
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="original-tab" data-bs-toggle="tab" data-bs-target="#original" type="button"
            role="tab" aria-controls="original" aria-selected="false">
            Original
          </button>
        </li>
      </ul>
      <div class="tab-content" id="schedule-tab">
        <div class="tab-pane fade show active" id="upcoming" role="tabpanel" aria-labelledby="upcoming-tab">
          <alert v-if="loan.status == 'paid'" type="success">
            The loan is fully paid.
          </alert>
          <div v-if="loan.status != 'paid'">
            <div class="d-flex justify-content-between mb-3">
              <h4>Upcoming Payments Schedule</h4>
              <a href="#" @click.prevent="downloadUpcoming"><i class="fal fa-download me-2"></i>Download</a>
            </div>
            <div class="table-responsive bg-white" v-if="!loading_upcoming">
              <table class=" table table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Date</th>
                  <th style="text-align: right">Balance</th>
                  <th style="text-align: right">Principal</th>
                  <th style="text-align: right">Interest</th>
                  <th style="text-align: right">Repayment</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, i) in upcoming" :key="`upcoming-${i}`">
                  <td>{{ row.month }}</td>
                  <td>{{ row.date }}</td>
                  <td align="right">{{ row.remaining_balance }}</td>
                  <td align="right">{{ row.principal }}</td>
                  <td align="right">{{ row.interest }}</td>
                  <td align="right">{{ row.total_payment }}</td>
                </tr>
              </tbody>
              </table>
            </div>

            <loading v-if="loading_upcoming" />
          </div>
        </div>
        <div class="tab-pane fade" id="original" role="tabpanel" aria-labelledby="original-tab">
          <div class="d-flex justify-content-between mb-3">
            <h4>Original Payments Schedule</h4>
            <a href="#" @click.prevent="downloadOriginal"><i class="fal fa-download me-2"></i>Download</a>
          </div>
          <div class="table-responsive bg-white" v-if="!loading_original">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Date</th>
                  <th style="text-align: right">Balance</th>
                  <th style="text-align: right">Principal</th>
                  <th style="text-align: right">Interest</th>
                  <th style="text-align: right">Repayment</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, i) in original" :key="`original-${i}`">
                  <td>{{ row.month }}</td>
                  <td>{{ row.date }}</td>
                  <td align="right">{{ row.remaining_balance }}</td>
                  <td align="right">{{ row.principal }}</td>
                  <td align="right">{{ row.interest }}</td>
                  <td align="right">{{ row.total_payment }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <loading v-if="loading_original" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loan: this.the_loan,
      loading_upcoming: false,
      loading_original: false,
    }
  },

  props: ["upcoming", "original", "the_loan"],

  methods: {
    downloadUpcoming() {
      this.loading_upcoming = true

      this.$axios.get(`/api/v1/admin/downloads/loans/${this.loan.id}/upcoming-schedule`).then(response => {
        window.open(response.data, '_blank')
        this.loading_upcoming = false
      })
    },

    downloadOriginal() {
      this.loading_original = true

      this.$axios.get(`/api/v1/admin/downloads/loans/${this.loan.id}/original-schedule`).then(response => {
        window.open(response.data, '_blank')
        this.loading_original = false
      })
    },
  }
};
</script>
